import Navigation from '../components/Navigation';

const Page5 = () => {
  return (
    <div className="page-container">
      <Navigation />
      <div style={{ backgroundColor: '#533483', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontFamily: 'Frijole, system-ui', fontSize: '2rem', flexDirection: 'column' }}>
        <div>
          <h1>🌊 Página 5 - O Oceano Inteiro! 🌊</h1>
          <div style={{ marginTop: '2rem', fontSize: '4rem' }}>
            🏆
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page5;
